import { render } from "./index.vue?vue&type=template&id=e27c2140&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=e27c2140&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e27c2140"

export default script